import React, { Component } from 'react';

class Portfolio extends Component {
  render() {
    return (
      <section id="portfolio">
        <div className="row projects">
          <div className="twelve columns collapsed">
            <h1>Check Out Some of My Works.</h1>
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/mario-sanz/pi-approximation" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/piapproximation-screenshot.png" alt="pi-approximation" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Pi Approximation</h3>
                      <p>App that approximates the Pi number based in the probability of a random dot being inside a circle or not. It also writes on the console the best approximation. The longer the program is ran, the better approximation we obtain.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        <li><a href="https://github.com/mario-sanz/pi-approximation/blob/main/README.md" className="button project-button" target="_blank" rel="noopener noreferrer">View Demo</a></li>
                        <li><a href="https://github.com/mario-sanz/pi-approximation" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className="devicon-javascript-plain technology"></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/mario-sanz/todo-list" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/todolist-screenshot.png" alt="todo-list" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Todo List</h3>
                      <p>Basic Todo list application built in JavaScript and Node.js to practice with these technologies. It contains a filter to search for specific tasks.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        <li><a href="https://github.com/mario-sanz/todo-list" className="button project-button" target="_blank" rel="noopener noreferrer">View Demo</a></li>
                        <li><a href="https://github.com/mario-sanz/todo-list" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className="devicon-javascript-plain technology"></i>
                        <i className="devicon-nodejs-plain technology"></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/mario-sanz/CA_gameOfLife" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/ca-gameoflife-screenshot.png" alt="ca-gameOfLife" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Game of Life</h3>
                      <p>Animated Conway's Game of Life using Matplotlib and Pygame. This is a visual example of a Cellular Automata and how they interact with their environment.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        <li><a href="https://github.com/mario-sanz/CA_gameOfLife/blob/main/README.md" className="button project-button" target="_blank" rel="noopener noreferrer">View Demo</a></li>
                        <li><a href="https://github.com/mario-sanz/CA_gameOfLife/blob/main/gameOfLife.py" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className="devicon-python-plain technology"></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/mario-sanz/Connect4-AI" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/connect4-screenshot.png" alt="connect4-ai" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Connect 4 with Artificial Intelligence</h3>
                      <p>Single player version of the Connect 4 game using Artificial Intelligence and the Minimax algorithm with a tree. There is also a two player version of this same game available at my GitHub profile.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        <li><a href="https://github.com/mario-sanz/Connect4-AI/blob/main/README.md" className="button project-button" target="_blank" rel="noopener noreferrer">View Demo</a></li>
                        <li><a href="https://github.com/mario-sanz/Connect4-AI/blob/main/connect4-AI.py" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className="devicon-python-plain technology"></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/mario-sanz/CA_triangles" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/ca-triangles-screenshot.png" alt="ca-triangles" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Cellular Automata - Triangles</h3>
                      <p>Practice of Cellular Automata that draws different triangles in the screen according to different laws given by the number. Each number has a different drawing behaviour depending on the painted/non-painted cells on their surroundings.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        <li><a href="https://github.com/mario-sanz/CA_triangles/blob/main/README.md" className="button project-button" target="_blank" rel="noopener noreferrer">View Demo</a></li>
                        <li><a href="https://github.com/mario-sanz/CA_triangles/blob/main/CA_triangles.py" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className="devicon-python-plain technology"></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a href="https://github.com/mario-sanz/Snake-game" className="image fit thumb" target="_blank" rel="noopener noreferrer"><img src="images/thumbs/snake-screenshot.png" alt="snake-game" /></a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Snake Game</h3>
                      <p>Classic <a href="https://en.wikipedia.org/wiki/Snake_(video_game_genre)" target="_blank" rel="noopener noreferrer">Snake Game</a> implemented with Python and the libraries Pygame and Tkinter for the GUI.</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        <li><a href="https://github.com/mario-sanz/Snake-game/blob/main/README.md" className="button project-button" target="_blank" rel="noopener noreferrer">View Demo</a></li>
                        <li><a href="https://github.com/mario-sanz/Snake-game/blob/main/snake.py" className="button project-button brands" target="_blank" rel="noopener noreferrer"><i className="fa fa-github icon"></i>View Source</a></li>
                      </div>
                      <div className="languages">
                        <i className="devicon-python-plain technology"></i>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <ul className="actions">
                <li className="wide-button"><a href="https://github.com/mario-sanz" className="button portfolio-button" target="_blank" rel="noopener noreferrer">Full Portfolio</a></li>
              </ul>
            </div>
          </div>
        </div>
   </section>
    );
  }
}

export default Portfolio;
